import {
    isValidElement,
    Children,
    type FC,
    useId
} from "react";
import {
    View
} from "react-native";
import type ISidebarGroupLabelProps from "./type";
import stylesheet, {
    SIDEBAR_GROUP_LABEL_VARIANT,
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    SidebarGroupLabelContext,
    useSidebarGroupContext,
    useSidebarRootContext
} from "../../context";
import {
    getSidebarActiveWeight
} from "../../stylesheet";
import SidebarGroupAction from "../groupAction";
import Text from "../../../text";

const SidebarGroupLabel: FC<ISidebarGroupLabelProps> = ({
    customTheme: customThemeProp,
    children,
    style,
    ...props
}) => {
    const root = useSidebarRootContext({
        part: "Sidebar.GroupLabel"
    });

    const group = useSidebarGroupContext({
        part: "Sidebar.GroupLabel"
    });

    const ownId = useId();

    const customTheme = customThemeProp ?? root?.customTheme;

    const {
        controlHeights,
        typography,
        borders,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const isCollapsed = root?.isCollapsed ?? false;

    const items = Children.toArray(children);

    const actions = items.filter((item) => isValidElement(item) && item.type === SidebarGroupAction);

    const content = items.filter((item) => !actions.includes(item));

    const {
        hiddenTitle: hiddenTitleDynamicStyle,
        separator: separatorDynamicStyle,
        container: containerDynamicStyle
    } = useStyles({
        controlHeights,
        isCollapsed,
        borders,
        colors,
        spaces
    });

    const weight = getSidebarActiveWeight({
        typography
    });

    const renderTitle = () => <Text
        style={[
            stylesheet.title,
            isCollapsed ? stylesheet.hiddenTitle : undefined,
            isCollapsed ? hiddenTitleDynamicStyle : undefined,
            weight === "600" ? {
                fontWeight: weight
            } : undefined
        ]}
        variant={SIDEBAR_GROUP_LABEL_VARIANT}
        id={group?.labelId ?? ownId}
        customTheme={customTheme}
        numberOfLines={1}
        color="mid"
    >
        {content}
    </Text>;

    if(isCollapsed) {
        return <View
            {...props}
            style={[
                style,
                stylesheet.container,
                containerDynamicStyle
            ]}
        >
            {renderTitle()}
            <View
                style={[
                    stylesheet.separator,
                    separatorDynamicStyle
                ]}
                aria-hidden={true}
            />
        </View>;
    }

    return <View
        {...props}
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
    >
        {renderTitle()}
        <SidebarGroupLabelContext.Provider
            value={true}
        >
            {actions}
        </SidebarGroupLabelContext.Provider>
    </View>;
};
export default SidebarGroupLabel;
